import { AuthGuard } from '@auth';
import { useUserProfile } from '@hooks';
import { BookmarkedSchools, ProfilePageWrapper } from '@profile';

export default function Faves() {
  const profile = useUserProfile();

  return (
    <ProfilePageWrapper pageTitle="Saved Schools">
      <AuthGuard>
        <BookmarkedSchools profile={profile} />
      </AuthGuard>
    </ProfilePageWrapper>
  );
}
